import { captureException } from '@sentry/react';

import { getAxiosSentryContext } from './get-axios-sentry-context';
import { shouldCaptureException } from './should-capture-exception';

export function captureExceptionSafely(error: unknown): void {
  if (!shouldCaptureException(error)) {
    return;
  }

  const axiosContext = getAxiosSentryContext(error);

  if (axiosContext) {
    captureException(error, axiosContext);
    return;
  }

  captureException(error);
}
